import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Patel",
      company: "Gujarat Fashion House",
      position: "Managing Director",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
      testimonial: `Kunjvihari Impex has been our trusted fabric supplier for over 8 years. Their fabric quality and commitment to excellence is unmatched. The team understands our requirements perfectly and always delivers on time.`,
      project: "Fashion Fabric Supply",
      location: "Ahmedabad, Gujarat"
    },
    {
      id: 2,
      name: "Priya Sharma",
      company: "Elegant Textiles",
      position: "Creative Director",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 5,
      testimonial: `The fabric quality from Kunjvihari Impex is exceptional. They helped us source premium Velvet Embroidery and Natural Crepe fabrics for our collection. Their product range and customer service are outstanding.`,
      project: "Premium Fabric Collection",
      location: "Surat, Gujarat"
    },
    {
      id: 3,
      name: "Amit Kumar",
      company: "Corporate Uniforms Ltd",
      position: "Procurement Head",
      avatar: "https://randomuser.me/api/portraits/men/56.jpg",
      rating: 5,
      testimonial: `Working with Kunjvihari Impex for our wholesale fabric requirements has been a game-changer. Their bulk supply capabilities and consistent quality have helped us serve our clients better.`,
      project: "Wholesale Fabric Supply",
      location: "Mumbai, Maharashtra"
    },
    {
      id: 4,
      name: "Meera Joshi",
      company: "Home Decor Creations",
      position: "Founder",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
      rating: 5,
      testimonial: `The fabric selection and customization options from Kunjvihari Impex are remarkable. They provided exactly the Polyester and Chinon fabrics we needed for our home textile line. Highly recommended for quality and variety.`,
      project: "Home Textile Fabrics",
      location: "Pune, Maharashtra"
    }
  ];

  const clientLogos = [
    { name: "Gujarat Fashion House", logo: "https://via.placeholder.com/120x60/1e3a8a/ffffff?text=GFH" },
    { name: "Elegant Textiles", logo: "https://via.placeholder.com/120x60/0891b2/ffffff?text=ET" },
    { name: "Corporate Uniforms", logo: "https://via.placeholder.com/120x60/f97316/ffffff?text=CU" },
    { name: "Home Decor Creations", logo: "https://via.placeholder.com/120x60/fbbf24/000000?text=HDC" },
    { name: "Premium Fabrics", logo: "https://via.placeholder.com/120x60/10b981/ffffff?text=PF" },
    { name: "Textile Innovations", logo: "https://via.placeholder.com/120x60/ef4444/ffffff?text=TI" }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials?.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [testimonials?.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-primary mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Discover why businesses across Gujarat and beyond trust Kunjvihari Impex for their fabric requirements. Our commitment to quality speaks through their success stories.
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative mb-16">
          <div className="max-w-4xl mx-auto">
            {testimonials?.map((testimonial, index) => (
              <div
                key={testimonial?.id}
                className={`transition-opacity duration-1000 ${
                  index === currentTestimonial ? 'opacity-100' : 'opacity-0 absolute inset-0'
                }`}
              >
                <div className="card-heritage p-8 md:p-12 text-center">
                  {/* Rating Stars */}
                  <div className="flex justify-center mb-6">
                    {[...Array(testimonial?.rating)]?.map((_, i) => (
                      <Icon key={i} name="Star" size={20} className="text-golden fill-current" />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <blockquote className="text-lg md:text-xl text-text-primary leading-relaxed mb-8 font-inter">
                    "{testimonial?.testimonial}"
                  </blockquote>

                  {/* Client Info */}
                  <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6">
                    <div className="flex items-center space-x-4">
                      <Image
                        src={testimonial?.avatar}
                        alt={testimonial?.name}
                        className="w-16 h-16 rounded-full object-cover"
                      />
                      <div className="text-left">
                        <div className="font-poppins font-semibold text-primary">
                          {testimonial?.name}
                        </div>
                        <div className="text-sm text-text-secondary">
                          {testimonial?.position}
                        </div>
                        <div className="text-sm font-medium text-secondary">
                          {testimonial?.company}
                        </div>
                      </div>
                    </div>

                    <div className="hidden md:block w-px h-16 bg-border"></div>

                    <div className="text-center md:text-left">
                      <div className="text-sm text-text-secondary mb-1">Project</div>
                      <div className="font-medium text-primary">{testimonial?.project}</div>
                      <div className="text-sm text-text-secondary flex items-center justify-center md:justify-start mt-1">
                        <Icon name="MapPin" size={14} className="mr-1" />
                        {testimonial?.location}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-center space-x-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 bg-surface border border-border rounded-full flex items-center justify-center text-text-secondary hover:bg-primary hover:text-primary-foreground transition-colors duration-200"
              aria-label="Previous testimonial"
            >
              <Icon name="ChevronLeft" size={20} />
            </button>

            <div className="flex space-x-2">
              {testimonials?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                    index === currentTestimonial ? 'bg-primary' : 'bg-border'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 bg-surface border border-border rounded-full flex items-center justify-center text-text-secondary hover:bg-primary hover:text-primary-foreground transition-colors duration-200"
              aria-label="Next testimonial"
            >
              <Icon name="ChevronRight" size={20} />
            </button>
          </div>
        </div>

        {/* Client Logos */}
        <div className="text-center">
          <h3 className="text-xl font-poppins font-semibold text-primary mb-8">
            Trusted by Leading Brands
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clientLogos?.map((client, index) => (
              <div
                key={index}
                className="flex items-center justify-center p-4 bg-surface rounded-lg hover:shadow-textile transition-shadow duration-300 grayscale hover:grayscale-0"
              >
                <Image
                  src={client?.logo}
                  alt={client?.name}
                  className="h-12 object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;